module.exports = __webpack_public_path__ + "static/media/Mobile-Auto.c428df22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Mobile-Auto.jpg
// module id = 124
// module chunks = 0